import { useQuery } from '@tanstack/react-query';

import {
  fetchHomeDashboard,
  type HomeDashboardDTO,
} from '@/api/adapters/home-dashboard';

export function useHomeDashboard() {
  return useQuery<HomeDashboardDTO>({
    queryKey: ['home-dashboard'],
    queryFn: fetchHomeDashboard,
    staleTime: 60_000,
  });
}
